import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { FORM } from "services/apiEndpoints";
import { privateGet, privatePost } from "services/privateRequest";
import { makeQueryString, randomIntFromInterval } from "utils/utils";
import { setPublish } from "./globalSlice";

const initialState = {
  droppedItems: [],
  isFetching: false,
  isFormulaDataFetching: false,
  formulaList: [],
  weights: [],
  formulaData: {},
  formData: {},
  selectedOptionsForFormula: {},
  scoreValue: [],

};

export const getFormulasData = createAsyncThunk(
  "formula/getFormulaData",
  async (id, { rejectWithValue, dispatch, signal }) => {
    try {
      const queryString = makeQueryString(`${FORM}/${id}/formula`);
      const { data } = await privateGet(queryString, { signal });
      const response = await privateGet(`${FORM}/${id}`);
      const formData = response?.data?.data;
      // console.log("data", data);
      if (data?.success) {
        return { formulaData: data?.data, formData };
      }
      // dispatch(setPageNumber(payload.pageNumber));
      // dispatch(setPageSize(payload.limit));
      // return {
      //     forms: data?.data?.forms || [],
      //     totalCount: data?.data?.totalForms || 0,
      // };
    } catch (error) {
      rejectWithValue(error);
      return error;
    }
  }
);
export const getFormulasDataById = createAsyncThunk(
  "formula/getFormulaData/id",
  async (payload, { rejectWithValue, dispatch, signal }) => {
    const { id, formulaId } = payload;
    try {
      const queryString = makeQueryString(`${FORM}/${id}/formula/${formulaId}`);
      const { data } = await privateGet(queryString, { signal });
      const response = await privateGet(`${FORM}/${id}`);
      const formData = response?.data?.data;
      //   dispatch(setFormId(res?.data?.data?._id));
      if (data?.success) {
        let list_array = [...formData?.fields];

        if (formData) {
          // Add fields from sections
          formData?.sections?.forEach((section) => {
            if (section?.fields?.length) {
              list_array = [...list_array, ...section.fields];
            }
          });

          // Recursively extract dependent fields
          const extractDependentFields = (fields) => {
            fields.forEach((field) => {
              if (field.dependentField && field.dependentField.length > 0) {
                list_array = [...list_array, ...field.dependentField];
                extractDependentFields(field.dependentField); // Recursively extract nested dependent fields
              }
            });
          };

          // Extract dependent fields from the initial list
          extractDependentFields(list_array);
        }


        if (data?.data?.weights?.length > 0) {
          const newData = data?.data?.weights?.map((e) => {
            const obj = list_array?.find((list) => list?._id == e?.fieldId);
            // console.log("obj", obj);
            const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);

            return {
              ...e,
              id: uniqueId,
              data: { id: uniqueId },
              type: obj?.type,
              name: obj?.label,
              formulaId: formulaId
            };
          });
          dispatch(setWeight(data?.data?.weights));
          dispatch(setDroppedItems(newData));
        }
        return { formulaData: data?.data, formData };
      }
      // dispatch(setPageNumber(payload.pageNumber));
      // dispatch(setPageSize(payload.limit));
      // return {
      //     forms: data?.data?.forms || [],
      //     totalCount: data?.data?.totalForms || 0,
      // };
    } catch (error) {
      rejectWithValue(error);
      return error;
    }
  }
);

export const postFormulasData = createAsyncThunk(
  "formula/postFormulaData",
  async (payload, { rejectWithValue, dispatch, signal }) => {
    const { id, datas } = payload;
    try {
      const queryString = makeQueryString(`${FORM}/${id}/formula`);
      const data = await privatePost(queryString, datas, { signal });
      if (data?.data?.success) {
        toast?.success(data?.data?.message);
        dispatch(setPublish(false));
      } else {
        toast?.error("Something Went Wrong!");
      }
      // dispatch(setPageNumber(payload.pageNumber));
      // dispatch(setPageSize(payload.limit));
      // return {
      //     forms: data?.data?.forms || [],
      //     totalCount: data?.data?.totalForms || 0,
      // };
    } catch (error) {
      console.log("error", error);
      rejectWithValue(error);
      return error;
    }
  }
);

const scoringSlice = createSlice({
  name: "scoring",
  initialState,
  reducers: {
    setDroppedItems: (state, action) => {
      state.droppedItems = action.payload;
    },
    setScoreValue: (state, action) => {
      // let uniqueVal = state.scoreValue?.reduce((acc,cr)=>{
      //   let obj = Object?.entries(cr)
      //   const [key,value] = obj


      // },[])
      state.scoreValue.unshift(action.payload)
    },
    clearScoreValue: (state, action) => {
      state.scoreValue = []
    },

    setField: (state, action) => {
      state.field = action.payload;
    },
    clearFormulaList: (state, action) => {
      state.formulaList = [];
    },
    setFilterWeights: (state, action) => {
      state.weights = state.weights.filter((e) => e.fieldId !== action.payload);
    },
    setWeight: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.weights = action.payload;
      } else {
        const index = state.weights.findIndex(
          (e) => e.fieldId === action.payload.fieldId
        );

        if (index !== -1) {
          state.weights[index] = { ...state.weights[index], ...action.payload };
        } else {
          state.weights.push(action.payload);
        }
      }
    },
    clearWeight: (state, action) => {
      state.weights = [];
    },
    clearDroppedItems: (state, action) => {
      state.droppedItems = [];
    },

    setRenderComponents: (state, action) => {
      state.renderComponents = action.payload;
    },
    setLastDroppedItemId: (state, action) => {
      state.lastDroppedItemId = action.payload;
    },

    setUpdateDroppedItems: (state, action) => {
      const { id, updatedData } = action.payload;

      // Update the droppedItems array
      state.droppedItems = state.droppedItems.map((item) => {
        if (item.id === id) {
          return { ...item, data: { ...item.data, ...updatedData } };
        } else return item;
      });
    },
    // setSelectedOptionsForFormula: (state, action) => {
    //   if (action.payload.value)
    //     state.selectedOptionsForFormula[action.payload.id] =
    //       action.payload.value;
    //   else delete state.selectedOptionsForFormula[action.payload.id];
    // },
    setSelectedOptionsForFormula: (state, action) => {
      state.selectedOptionsForFormula[action.payload.id] = action.payload.value ?? "";
    },

    clearSelectedOptionsForFormula: (state) => {
      state.selectedOptionsForFormula = {};
    },
    setFormulaData: (state, action) => {
      state.formulaData[action.payload.key] = action.payload.value;
    },
    setFormulaLabel: (state, action) => {
      state.formulaData.label = action.payload;
    },
    setFormulaType: (state, action) => {
      state.formulaData.formulaType = action.payload;
    },
  },
  extraReducers: {
    [getFormulasData.pending]: (state) => {
      state.isFormulaDataFetching = true;
    },
    [getFormulasData.fulfilled]: (state, action) => {
      state.formulaList = action?.payload?.formulaData || [];
      state.formData = action?.payload?.formData || {};

      state.isFormulaDataFetching = false;
    },
    [getFormulasData.rejected]: (state) => {
      state.isFormulaDataFetching = false;
    },
    [getFormulasDataById.pending]: (state) => {
      state.isFetching = true;
    },
    [getFormulasDataById.fulfilled]: (state, action) => {
      state.formulaData = action.payload.formulaData;
      state.formData = action.payload.formData;
      state.isFetching = false;
    },
    [getFormulasDataById.rejected]: (state) => {
      state.isFetching = false;
    },
    [postFormulasData.pending]: (state) => {
      state.isFetching = true;
    },
    [postFormulasData.fulfilled]: (state, action) => {
      // state.formula = action.payload;
      state.isFetching = false;
    },
    [postFormulasData.rejected]: (state) => {
      state.isFetching = false;
    },
    [getFormulasData.pending]: (state) => {
      state.isFormulaDataFetching = true;
    },
    [getFormulasData.fulfilled]: (state, action) => {
      state.formulaList = action?.payload?.formulaData || [];
      state.formData = action?.payload?.formData || {};

      state.isFormulaDataFetching = false;
    },
    [getFormulasData.rejected]: (state) => {
      state.isFormulaDataFetching = false;
    },
    [getFormulasDataById.pending]: (state) => {
      state.isFetching = true;
    },
    [getFormulasDataById.fulfilled]: (state, action) => {
      state.formulaData = action.payload.formulaData;
      state.formData = action.payload.formData;
      state.isFetching = false;
    },
    [getFormulasDataById.rejected]: (state) => {
      state.isFetching = false;
    },
    [postFormulasData.pending]: (state) => {
      state.isFetching = true;
    },
    [postFormulasData.fulfilled]: (state, action) => {
      // state.formula = action.payload;
      state.isFetching = false;
    },
    [postFormulasData.rejected]: (state) => {
      state.isFetching = false;
    },
  },
});

export const {
  setDroppedItems,
  clearScoreValue,
  setFilterWeights,
  setLastDroppedItemId,
  setUpdateDroppedItems,
  setSelectedName,
  setSelectedData,
  setRightPanelSectionData,
  setPreReviewModalOpen,
  setToggle,
  setToggleCheck,
  setPageNumber,
  setRenderComponents,
  setPageSize,
  setWeight,
  clearFormulaList,
  setField,
  clearDroppedItems,
  clearWeight,
  setScoreValue,
  clearSelectedOptionsForFormula,
  setFormulaData,
  setFormulaLabel,
  setFormulaType,
  setSelectedOptionsForFormula,
} = scoringSlice.actions;
export default scoringSlice.reducer;
